import React from 'react'
import styled from 'styled-components'

export default ({ image = '/new-ndi-logo.png', width = 125, height = 26}) => (
    <Style href="https://www.nucleusinnovation.ch" rel="noopener noreferrer">
        <img src={image} width={width} height={height} alt={'Nucleus Innovation'} />
    </Style>
)

const Style = styled.a.attrs(props => ({
    className: 'logo'
}))`
    display: inline-flex;
    justify-content: flex-start;

    img {
        margin-bottom: 0;
    }
`